import React from "react"

export type CtxType = {
  removeFacility: Function
  facilitiesList: Record<string, any>
  isValidating: boolean
}

export const Context = React.createContext<Partial<CtxType>>({})
